import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SubscriptionListTab } from "@/components/subscriptions/subscription-list-tab";
import { SubscriptionAnalyticsTab } from "@/components/subscriptions/subscription-analytics-tab";

export default function SubscriptionsPage() {
  return (
    <div className="space-y-4 md:space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">구독 관리</h1>
        <p className="text-muted-foreground leading-normal">
          사용자 구독을 조회하고 관리합니다.
        </p>
      </div>

      <Tabs defaultValue="list" className="space-y-4 md:space-y-6">
        <TabsList className="group-data-[orientation=horizontal]/tabs:h-12 p-1.5 bg-zinc-200/80 rounded-xl">
          <TabsTrigger
            value="list"
            className="text-base px-8 h-full rounded-lg text-foreground/70 data-[state=active]:text-foreground data-[state=active]:bg-background data-[state=active]:shadow-md font-medium"
          >
            구독 목록
          </TabsTrigger>
          <TabsTrigger
            value="analytics"
            className="text-base px-8 h-full rounded-lg text-foreground/70 data-[state=active]:text-foreground data-[state=active]:bg-background data-[state=active]:shadow-md font-medium"
          >
            분석
          </TabsTrigger>
        </TabsList>

        <TabsContent value="list" className="space-y-4">
          <SubscriptionListTab />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-4">
          <SubscriptionAnalyticsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
